import React, { Component } from 'react';
import MapaModal from './mapaModal';
import InfoViaje from './InfoViaje';
import firebase from 'firebase';
import start from '../../img/start.png'
import Alert from 'react-s-alert';
import geofire from 'geofire';
import BarraButtom from './BaraButtom';
import pasajeros from '../../img/pasajeros.png';
import Pasajeros from './pasajeros';
import { withRouter } from 'react-router-dom';
import dormir from '../../img/dormir.png';
import Modal from 'react-modal';
import penaLogo from '../../img/loginLogo.png';
import powered from '../../img/powered.png';
import ubicar from '../../img/location.png';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        width: '500px',
        height: '200px',
    }
};

const google = window.google;
var id;
var interval;
var options = {
    enableHighAccuracy: true,
    timeout: 3000,
    maximumAge: 3000,
    distanceFilter: 25
};

const DirectionsService = new google.maps.DirectionsService();

class MapaEspera extends Component {
    constructor(props) {
        super(props);
        this.state = {
            coordenadas: [],
            color: '',
            isSinc: false,
            alto: '110%',
            coordE: {},
            showSyncButton: true,
            kmInicial: '',
            kmFinal: '',
            isCarretera: '-1',
            carreteras: [],
            velocidad: 0,
            isPoint: false,
            point: '',
            isPasajero: false,
            done: false,
            actual: 0,
            isMulti:false,
            markers:[]
        };
        this.handleChange = this.handleChange.bind(this);
        this.showPosition = this.showPosition.bind(this);

    }
    error = (err) => {
        navigator.geolocation.clearWatch(id);
        setTimeout(() => {
            this.getPosition();
        }, 2000);
    };

    getPosition = () => {
        id = navigator.geolocation.watchPosition(this.showPosition, this.error, options);
    }

    showPosition = (position) => {
        let { coords } = position;
        let speed = coords.speed !== null ? coords.speed : 0;
        let isOverLimit = speed.toFixed(2);
        let { userRuta, userViaj, userActu } = this.props;
        let coordE = { lat: coords.latitude, lng: coords.longitude };
        let act = [];
        if (userActu.viajeAsignado !== false) {
            let dist = -1;
            let dest = [];
            let actual = 0;
            act.push(Number(coords.latitude));
            act.push(Number(coords.longitude));
            let paradas = userRuta.paradas || [];
            paradas.splice(0, 0, { coordenadas: userRuta.inicio.coordenadas });
            paradas.push({ coordenadas: userRuta.destino.coordenadas })
            for (let i = 0; i < paradas.length; i++) {
                let destinoA = paradas[i].coordenadas.split(',');
                dest.push(Number(destinoA[0]));
                dest.push(Number(destinoA[1]));
                let t = geofire.distance(act, dest).toFixed(2);
                if (dist === -1) { dist = t; actual = i; }
                if (dist > t) { dist = t; actual = i; }
                dest = [];
            }
            if (dist <= 0.3) {
                let i = userViaj.waypointOrder === undefined ? 0 : userViaj.waypointOrder[userViaj.puntoA];
                this.setState({ isPoint: true, point: paradas[i], actual, velocidad: isOverLimit});
            } else {
                this.setState({ isPoint: false, point: '', done: false, velocidad: isOverLimit })
            }
            this.setState({ coordE })
            if (userViaj.conductor !== undefined) {
                firebase.database().ref().child('EmpleadosGPS/' + userViaj.conductor).update({
                    latitud: position.coords.latitude,
                    longitud: position.coords.longitude,
                    velocidad: isOverLimit
                })
            }
            firebase.database().ref().child('DatosViajes/' + userActu.viajeAsignado).update({
                vActual: isOverLimit
            })
        } else {
            this.setState({ coordE })
        }
    }

    componentWillUnmount() {
        this.clearNavigatorWatch(id);
        clearInterval(interval);
    }

    clearNavigatorWatch(id) {
        navigator.geolocation.clearWatch(id);
    }


    getVelo = () => {
        interval = setInterval(() => {
            let { velocidad } = this.state;
            let { userActu } = this.props;
            if (userActu.viajeAsignado !== false && userActu.viajeAsignado !== undefined && userActu.viajeAsignado !== 'false' && userActu.viajeAsignado !== 'undefined') {
                firebase.database().ref('DatosViajes/' + userActu.viajeAsignado + '/velocidad').once('value').then(snap => {
                    let data = snap.val();
                    if (data !== null) {
                        var last = data[data.length - 1]
                        if (last !== Number(velocidad)) {
                            firebase.database().ref('DatosViajes/' + userActu.viajeAsignado + '/velocidad').update({ [data.length]: Number(velocidad) })
                        }
                    } else {
                        firebase.database().ref('DatosViajes/' + userActu.viajeAsignado + '/velocidad').update({ 0: Number(velocidad) })
                    }
                })
            }
        }, 10000);
    }

    componentWillMount = () => {
        firebase.database().ref('Carreteras').once('value').then(snapC => {
            let carreteras = [];
            snapC.forEach(element => {
                let datos = element.val();
                carreteras.push({ label: datos.valor, value: element.key })
            });
            this.setState({ carreteras })
        })
    }

    componentDidMount() {
        navigator.geolocation.getCurrentPosition(this.showPosition);
        this.getPosition();
        let { userViaj, userActu } = this.props;
        if (userActu.viajeAsignado !== false) {
            if (userViaj.estado === 'iniciado') {
                this.setState({ alto: '90%' })
            }
            firebase.database().ref('Rutas/' + userViaj.ruta).once('value').then(snapR => {
                let ruta = snapR.val();
                let color = ruta.coloRuta;
                let paradas = [];
                let markers = [];
                let ini = ruta.inicio.coordenadas.split(',');
                markers.push({
                    location: new google.maps.LatLng(ini[0], ini[1]),
                    name:ruta.inicio.nombre
                })
                if (Array.isArray(ruta.paradas)) {
                    ruta.paradas.forEach(element => {
                        let coord = element.coordenadas.split(',');
                        paradas.push({
                            location: new google.maps.LatLng(coord[0], coord[1]),
                            stopover: true
                        })
                        markers.push({
                            location: new google.maps.LatLng(coord[0], coord[1]),
                            name:element.referencia
                        })
                    });
                }
                let dest = ruta.destino.coordenadas.split(',');
                markers.push({
                    location: new google.maps.LatLng(dest[0], dest[1]),
                    name:ruta.destino.nombre
                })
                let tama = ruta.paradas!== undefined?ruta.paradas.length:'';
                if (tama > 23 && tama !== '') {
                    let resto = tama % 23;
                    let divisor = tama / 23;
                    let inicio = 0;
                    let inicioD ='';
                    let destinoD = '';
                        for (let indexP = 1; indexP <= (divisor + 1); indexP++) {
                            let paradas2 = [];
                            if (Array.isArray(ruta.paradas)) {
                                for (let index = inicio; index < (23*indexP); index++) {
                                    if(ruta.paradas[index] !== undefined){
                                        let coord = ruta.paradas[index].coordenadas.split(',');
                                        paradas2.push({
                                            location: new google.maps.LatLng(coord[0], coord[1]),
                                            stopover: true,
                                        })
                                        inicio++;
                                    }
                                }
                                if(indexP === 1){
                                    inicioD = ruta.inicio.coordenadas.split(',');
                                    destinoD = ruta.paradas[inicio-1].coordenadas.split(',');
                                    this.getRoutes(ruta, userActu, paradas2,inicioD, destinoD );
                                    inicioD = ruta.paradas[inicio-1].coordenadas.split(',');
                                }else{
                                    let numero = String(divisor).charAt(0);
                                    if(indexP !== (Number(numero) + 1)){
                                        destinoD = ruta.paradas[inicio-1].coordenadas.split(',');
                                        this.getRoutes(ruta, userActu, paradas2,inicioD, destinoD );
                                        inicioD = ruta.paradas[inicio-1].coordenadas.split(',');
                                    }
                                    else{
                                        destinoD = ruta.destino.coordenadas.split(',');
                                        this.getRoutes(ruta, userActu, paradas2,inicioD, destinoD );
                                    }
                                }
                            }
                        }
                } else {
                    let inicio = ruta.inicio.coordenadas.split(',');
                    let destino = ruta.destino.coordenadas.split(',');
                    DirectionsService.route({
                        origin: new google.maps.LatLng(inicio[0], inicio[1]),
                        destination: new google.maps.LatLng(destino[0], destino[1]),
                        waypoints: paradas,
                        travelMode: google.maps.TravelMode.DRIVING,
                    }
                        , (result, status) => {
                            if (status === google.maps.DirectionsStatus.OK) {
                                firebase.database().ref().child('ProgramacionDia/' + userActu.viajeAsignado).update({
                                    waypointOrder: result.routes[0].waypoint_order
                                })
                                this.setState({ coordenadas: result, isMulti:false })
                            } else {
                                console.error(`error fetching directions ${result}`);
                            }
                        })
                }
                this.setState({ ruta, paradas, color, markers })
            })
        }
        this.getVelo();
    }

    getRoutes = (ruta,userActu, paradas, inicio, destino) => {
        DirectionsService.route({
            origin: new google.maps.LatLng(inicio[0], inicio[1]),
            destination: new google.maps.LatLng(destino[0], destino[1]),
            waypoints: paradas,
            travelMode: google.maps.TravelMode.DRIVING,
        }
            , (result, status) => {
                if (status === google.maps.DirectionsStatus.OK) {
                    firebase.database().ref().child('ProgramacionDia/' + userActu.viajeAsignado).update({
                        waypointOrder: result.routes[0].waypoint_order
                    })
                    this.setState({ coordenadas:[...this.state.coordenadas, result], isMulti:true })
                } else {
                    console.error(`error fetching directions ${result}`);
                }
            })
    }

    componentDidUpdate(prevProps) {
        if (this.props.userActu !== prevProps.userActu) {
            let { userViaj, userActu } = this.props;
        if (userActu.viajeAsignado !== false) {
            if (userViaj.estado === 'iniciado') {
                this.setState({ alto: '90%' })
            }
            firebase.database().ref('Rutas/' + userViaj.ruta).once('value').then(snapR => {
                let ruta = snapR.val();
                let color = ruta.coloRuta;
                let paradas = [];
                let markers = [];
                let ini = ruta.inicio.coordenadas.split(',');
                markers.push({
                    location: new google.maps.LatLng(ini[0], ini[1]),
                    name:ruta.inicio.nombre
                })
                if (Array.isArray(ruta.paradas)) {
                    ruta.paradas.forEach(element => {
                        let coord = element.coordenadas.split(',');
                        paradas.push({
                            location: new google.maps.LatLng(coord[0], coord[1]),
                            stopover: true
                        })
                        markers.push({
                            location: new google.maps.LatLng(coord[0], coord[1]),
                            name:element.referencia
                        })
                    });
                }
                let dest = ruta.destino.coordenadas.split(',');
                markers.push({
                    location: new google.maps.LatLng(dest[0], dest[1]),
                    name:ruta.destino.nombre
                })
                let tama = ruta.paradas!== undefined?ruta.paradas.length:'';
                if (tama > 23 && tama !== '') {
                    let resto = tama % 23;
                    let divisor = tama / 23;
                    let inicio = 0;
                    let inicioD ='';
                    let destinoD = '';
                        for (let indexP = 1; indexP <= (divisor + 1); indexP++) {
                            let paradas2 = [];
                            if (Array.isArray(ruta.paradas)) {
                                for (let index = inicio; index < (23*indexP); index++) {
                                    if(ruta.paradas[index] !== undefined){
                                        let coord = ruta.paradas[index].coordenadas.split(',');
                                        paradas2.push({
                                            location: new google.maps.LatLng(coord[0], coord[1]),
                                            stopover: true,
                                        })
                                        inicio++;
                                    }
                                }
                                if(indexP === 1){
                                    inicioD = ruta.inicio.coordenadas.split(',');
                                    destinoD = ruta.paradas[inicio-1].coordenadas.split(',');
                                    this.getRoutes(ruta, userActu, paradas2,inicioD, destinoD );
                                    inicioD = ruta.paradas[inicio-1].coordenadas.split(',');
                                }else{
                                    let numero = String(divisor).charAt(0);
                                    if(indexP !== (Number(numero) + 1)){
                                        destinoD = ruta.paradas[inicio-1].coordenadas.split(',');
                                        this.getRoutes(ruta, userActu, paradas2,inicioD, destinoD );
                                    }
                                    else{
                                        destinoD = ruta.destino.coordenadas.split(',');
                                        this.getRoutes(ruta, userActu, paradas2,inicioD, destinoD );
                                    }
                                }
                            }
                        }
                } else {
                    let inicio = ruta.inicio.coordenadas.split(',');
                    let destino = ruta.destino.coordenadas.split(',');
                    DirectionsService.route({
                        origin: new google.maps.LatLng(inicio[0], inicio[1]),
                        destination: new google.maps.LatLng(destino[0], destino[1]),
                        waypoints: paradas,
                        travelMode: google.maps.TravelMode.DRIVING,
                    }
                        , (result, status) => {
                            if (status === google.maps.DirectionsStatus.OK) {
                                firebase.database().ref().child('ProgramacionDia/' + userActu.viajeAsignado).update({
                                    waypointOrder: result.routes[0].waypoint_order
                                })
                                this.setState({ coordenadas: result, isMulti:false })
                            } else {
                                console.error(`error fetching directions ${result}`);
                            }
                        })
                }
                this.setState({ ruta, paradas, color, markers })
            })
        }
            
        }
        if (this.props.userViaj !== prevProps.userViaj) {

        }
    }

    handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }

    center = () => {

        let {coordE} = this.state;

        this.setState({coordE});

    }

    startViaje = () => {
        let { kmInicial } = this.state;
        if (kmInicial !== '') {
            let { userActu, userViaj } = this.props;
            if (userViaj.estado === 'sinced') {
                firebase.database().ref().child('ProgramacionDia/' + userActu.viajeAsignado).update({
                    estado: 'iniciado',
                    inicio: firebase.database.ServerValue.TIMESTAMP,
                    kmInicial: kmInicial
                })
                this.setState({ alto: '90%', isActiveI: false })
                window.scrollTo(0, 0);
            }
            else {
                Alert.error('Favor sincronize el escaner antes de iniciar el viaje', {
                    effect: 'genie',
                    position: 'bottom-right',
                    timeout: 2000
                });
            }
        }
        else {
            Alert.error('Favor proporcione el km inicial para iniciar con el viaje', {
                effect: 'genie',
                position: 'bottom-right',
                timeout: 2000
            });
        }
    }

    sincData = () => {
        let { userViaj } = this.props;
        if (userViaj.estado === 'Pendiente') {
            this.setState({ isSinc: true })
        }
        else {
            Alert.warning('Escaner actualemente enlazado', {
                effect: 'genie',
                position: 'bottom-right',
                timeout: 4000
            });
        }
    }

    handleChange(event) {
        let { userActu } = this.props;
        firebase.database().ref().child('SyncApps').orderByChild('codigo').equalTo(event.target.value).once('value').then(snap => {
            let data = snap.val();
            if (data !== null) {
                snap.forEach(element => {
                    let data = element.val();
                    firebase.database().ref().child('SyncApps/' + element.key).update({
                        programacionDia: userActu.viajeAsignado
                    })
                    firebase.database().ref().child('ProgramacionDia/' + userActu.viajeAsignado).update({
                        estado: 'sinced'
                    })
                    Alert.success('Escaner sincronizado con exito', {
                        effect: 'genie',
                        position: 'bottom-right',
                        timeout: 4000
                    });
                    this.setState({ isSinc: false, showSyncButton: false })
                });
            }
        })
    }

    showPasa = () => {
        this.setState({ isPasajero: true })
    }

    closePasa = () => {
        this.setState({ isPasajero: false })
    }

    desacivar = () => {
        let { userActu } = this.props;
        firebase.database().ref().child('Empleados/' + userActu.key).update({
            espera: false
        })
    }

    nuevoMark = () => {
        this.setState({ done: true })
    }

    viejoMark = () => {
        this.setState({ done: false })
    }

    toggleModalG(index) {
        let active = 'isActive' + index;
        this.setState({ [active]: !this.state[active] })
    }

    handleKeyPressNumeros(e) {
        let tecla = e.which;
        let patron = /^[0-9]+$/;
        let tecla_final = String.fromCharCode(tecla);
        let rs = patron.test(tecla_final);
        if (!rs) { e.preventDefault(); }
    }

    render() {
        let { userActu, userVehi, userViaj, userRuta } = this.props;
        let { coordenadas, color, isSinc, alto, coordE, isPoint, point, isPasajero, done, carreteras, actual, isMulti,
              markers } = this.state;
        return (
            <div>
                <div className='absolute2' >
                {userActu.viajeAsignado === false &&
                        <div>
                            <img onClick={() => this.desacivar()} className='imgC dormir' src={dormir} alt="descanso" />
                            <img className='imgP1' onClick={() => this.center()} src={ubicar} alt="menu" />
                        </div>
                    }
                    
                    {userActu.viajeAsignado !== false &&
                        <img className='imgP1' onClick={() => this.center()} src={ubicar} alt="menu" />
                    }
                    <MapaModal
                        googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBWSezH7j1VKwfE36I0gsaaL8UwZh7cT0M&v=3.exp&libraries=geometry,drawing,places"
                        loadingElement={<div style={{ height: `100%` }} />}
                        containerElement={<div style={{ height: alto }} />}
                        mapElement={<div style={{ height: `100%` }} />}
                        direccion={coordenadas}
                        color={color}
                        coordE={coordE}
                        visible={userActu.viajeAsignado}
                        isMulti={isMulti}
                        markers={markers}
                    />
                </div>
                {(userActu.viajeAsignado !== false && userViaj.estado === 'Pendiente' || userViaj.estado === 'sinced') &&
                    <div>
                        <img className='imgP2' onClick={() => this.center()} src={ubicar} alt="menu" />
                        <div className='absolute'>
                            <InfoViaje sincData={() => this.sincData()} showButton={this.state.showSyncButton} userActu={userActu} userVehi={userVehi} userViaj={userViaj} />
                        </div>
                        <div className='absoluteB'>
                            <img onClick={() => this.toggleModalG('I')} className='imgC' src={start} alt="menu" />
                        </div>

                        {isSinc &&
                            <div className='modalAb'>
                            <span style={{ color: 'white', fontFamily: 'lato', fontSize: 24, right: 15, top: 10, position: 'absolute' }} onClick={() => this.setState({ isSinc: false })}>X</span>
                        <div className='centroFix'>
                        <img src={penaLogo} className="resizeLogo centroFixLogo"/>
                            <p style={{ color: 'white', fontFamily: 'lato', fontSize: 16}}>DIGITE EL CÓDIGO QUE APARECE EN LA PANTALLA DEL LECTOR</p>
                            <input style={{ backgroundColor: 'transparent', borderColor: 'transparent', borderBottomColor: 'white', color: 'white', paddingLeft: 0, marginTop: 30 }} className="form-control"
                                value={this.state.value} onChange={this.handleChange} />
                                <img className="powered" src={powered}/>
                                </div>
                        </div>
                        }
                    </div>
                }
                {(userViaj.estado === 'iniciado') &&
                    <div>
                        <div className='absoluteButtom'>
                            <BarraButtom isPoint={isPoint} donee={done} actual={actual} carreteras={carreteras} done={this.nuevoMark} point={point} stopWatch={() => this.clearNavigatorWatch(id)} coords={this.state.coordE} userRuta={userRuta} userActu={userActu} userViaj={userViaj} />
                        </div>
                    </div>
                }
                {(userActu.viajeAsignado !== false && userViaj.estado === 'iniciado') &&
                    <div className='absoluteTopRig'>
                        <img onClick={this.showPasa} className='imgC' src={pasajeros} alt="menu" />
                    </div>
                }
                {isPasajero &&
                    <div className='absoluteIz'>
                        <Pasajeros closePasa={() => this.closePasa()} point={point} userRuta={userRuta} userActu={userActu} userViaj={userViaj} />
                    </div>
                }
                <Modal isOpen={this.state['isActiveI']} onRequestClose={() => this.toggleModalG('I')} style={customStyles}>
                    <div className="form-group">
                        <label htmlFor="nombre">KM Inicial</label>
                        <input type="text" name="kmInicial" className="form-control" onChange={this.handleInputChange}
                            placeholder="kM Inicial" required autoComplete="off" onKeyPress={this.handleKeyPressNumeros} />
                    </div>
                    <button onClick={this.startViaje} className="btn btn-primary buttons">Guardar</button>
                </Modal>
            </div>
        )
    }
}
export default withRouter(MapaEspera);


// WEBPACK FOOTER //
// ./src/Components/perfilEmpleado/MapaEspera.js